/**
 * planStepCopy.ts — the plan screen's two choices, in the order it asks them,
 * and the checkout loader's short form of them.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: checkout, the pre-plan
 * loader (CTO, 2026-09-25).
 *
 * `PlanSelection` asks the patient two things on BOTH of its layouts — the
 * single-page builder (numbered step headings under "Build your plan") and the
 * recommendation-filtered two-step chooser (one heading per screen): first the
 * treatment, then the commitment. They are named here, and `PlanSelection`
 * prints these constants, because the checkout loader in front of that screen
 * names its first step from them (`checkoutLoaderContent.ts`). One wording, so
 * the loader can never describe a plan screen that has since changed.
 *
 * Category-level: no medicine, form or price (R28 applies to the loader even
 * though this screen is post-eligibility).
 */

/** Step 1 of the plan screen, on both layouts. */
export const PLAN_STEP_TREATMENT = 'Choose your treatment';

/** Step 2 of the plan screen, on both layouts. */
export const PLAN_STEP_COMMITMENT = 'Choose your weight loss commitment';

/**
 * SHORT FORM of the plan screen's two choices — the checkout loader card's
 * FIRST step headline (2026-09-25, CTO: "too much text … use very catchy
 * text"). SOURCES: {@link PLAN_STEP_TREATMENT} (step 1 of the plan screen,
 * built in, so a reword of it moves this line too) joined to the Result
 * screen's tracker step the patient has just been told is next, "Choose your
 * plan" (`journey/resultCopy.ts` `RESULT_PLAN_STEP`). An instruction about the
 * next screen, not a claim: it promises no particular treatment, and names
 * none (R28). `checkoutLoaderContent.spec` pins both halves to their sources.
 */
export const CHOOSE_TREATMENT_AND_PLAN = `${PLAN_STEP_TREATMENT} & plan`;
